module.exports = __webpack_public_path__ + "static/img/page5-tip.71b37de.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/listen-report/page5-tip.png
// module id = xogB
// module chunks = 216